/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lost_Sweet_Fish_SailInputs */

const es_lost_sweet_fish_sail = /** @type {(inputs: Lost_Sweet_Fish_SailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ya tienes una cuenta?`)
};

const gl_lost_sweet_fish_sail = /** @type {(inputs: Lost_Sweet_Fish_SailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xa tes unha conta?`)
};

const en_lost_sweet_fish_sail = /** @type {(inputs: Lost_Sweet_Fish_SailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already have an account?`)
};

/**
* | output |
* | --- |
* | "Already have an account?" |
*
* @param {Lost_Sweet_Fish_SailInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const lost_sweet_fish_sail = /** @type {((inputs?: Lost_Sweet_Fish_SailInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lost_Sweet_Fish_SailInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_lost_sweet_fish_sail(inputs)
	if (locale === "en") return en_lost_sweet_fish_sail(inputs)
	return es_lost_sweet_fish_sail(inputs)
});